import React from "react";
import SvgIconBase from "./SvgIconBase";
import { SvgIconProps } from "@mui/material/SvgIcon";

export const UsersIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase {...props}>
    <svg
      fill="#8F95B2"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 22 22"
    >
      <path
        d="M11,13h0.4c1.9,0,6.3,0.2,6.3,3.2c0,3-4.3,3.2-6.3,3.2h-0.8c-1.9,0-6.3-0.2-6.3-3.2c0-3,4.4-3.2,6.3-3.2l0.3,0
	C10.9,13,11,13,11,13z M11,14.5c-2.4,0-5.2,0.3-5.2,1.7c0,1.4,2.7,1.7,5,1.7l0.2,0c2.4,0,5.2-0.3,5.2-1.7
	C16.2,14.8,13.4,14.5,11,14.5z M19,12.6c2.4,0.4,2.9,1.5,2.9,2.4c0,0.5-0.2,1.5-1.6,2.1c-0.4,0.1-0.8,0-1-0.4c-0.1-0.4,0-0.8,0.4-1
	c0.7-0.3,0.7-0.5,0.7-0.7c0-0.4-0.6-0.7-1.7-0.9c-0.4-0.1-0.7-0.4-0.6-0.9C18.2,12.8,18.5,12.6,19,12.6z M3.9,13.2
	C4,13.7,3.7,14,3.3,14.1c-1.1,0.2-1.7,0.5-1.7,0.9c0,0.1,0,0.4,0.7,0.7c0.4,0.1,0.6,0.6,0.4,1c-0.1,0.4-0.6,0.6-1,0.4
	c-1.4-0.5-1.6-1.5-1.6-2.1c0-0.9,0.5-2,2.9-2.4C3.5,12.6,3.8,12.8,3.9,13.2z M11,2.6c2.5,0,4.6,2.1,4.6,4.6c0,2.5-2,4.6-4.6,4.6h0
	c-1.2,0-2.4-0.5-3.2-1.3c-0.9-0.9-1.3-2-1.3-3.2C6.4,4.7,8.5,2.6,11,2.6L11,2.6z M11,4.1c-1.7,0-3.1,1.4-3.1,3.1
	c0,0.8,0.3,1.6,0.9,2.2c0.6,0.6,1.3,0.9,2.2,0.9l0,0.8v-0.8c1.7,0,3.1-1.4,3.1-3.1C14.1,5.5,12.7,4.1,11,4.1z M17.2,3.6
	c1.8,0.3,3,1.8,3,3.6c0,1.8-1.3,3.3-3.1,3.6c-0.4,0.1-0.8-0.2-0.8-0.6s0.2-0.8,0.6-0.8c1-0.2,1.8-1,1.8-2.1c0-1-0.8-1.9-1.8-2.1
	c-0.4-0.1-0.7-0.5-0.6-0.9C16.4,3.8,16.8,3.5,17.2,3.6L17.2,3.6L17.2,3.6z M5.7,4.2C5.7,4.6,5.5,5,5.1,5.1C4,5.2,3.3,6.1,3.3,7.2
	c0,1.1,0.8,1.9,1.8,2.1c0.4,0.1,0.7,0.4,0.6,0.8c-0.1,0.4-0.4,0.7-0.8,0.6C3.1,10.5,1.8,9,1.8,7.2c0-1.8,1.3-3.3,3-3.6
	C5.2,3.5,5.6,3.8,5.7,4.2C5.7,4.2,5.7,4.2,5.7,4.2L5.7,4.2z"
      />
    </svg>
  </SvgIconBase>
);
